enum LoanPayoutFigureSectionTypeEnum {
    DefaultFees = 'DEFAULT_FEES',
    Interest = 'INTEREST',
    Other = 'OTHER',
    Principal = 'PRINCIPAL',
    Renewal = 'RENEWAL',
}

export default LoanPayoutFigureSectionTypeEnum;
